<template>
    <div class="supervisor">
        <div class="app-content content px-1 py-2">
            <div class="content-wrapper">
                <backToDashboard></backToDashboard>
                <div class="content-header row">
                    <div class="content-header-left col-md-4 col-12 mb-2">
                    <h2 class="content-header-title mt-4 mb-0 d-inline-block">Paramètres agent</h2>
                    <fieldset class="mt-2 form-group position-relative">
                        <select class="form-control" id="DefaultSelect" v-on:change="goToSettings">
                        <option>Mes paramètres</option>
                        <option selected="">Paramètres agent</option>
                        </select>
                    </fieldset>
                    </div>
                </div>
                <div class="content-body">
                    <section id="basic-examples">
                        <div class="row">
                            <div class="col-3">
                                <div class="media-list">
                                    <div class="card">
                                        <div class="card-header border-bottom" v-for="(skill, index) in AllSkills" :key="index + 'skill'" v-on:click="updateAgents(skill.uuid)">
                                            <router-link  class="card-title text-dark d-block" :to="{ name: 'skillView', params: {skill: skill.label}}">{{skill.label}}</router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-9">
                                <router-view/>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import backToDashboard from '../components/layout/backToDashboard.vue'

export default {
  components: {
    'backToDashboard': backToDashboard
  },
  computed: {
    AllSkills () {
      return this.$store.getters.getSkills
    }
  },
  methods: {
    updateAgents (uuid) {
      this.$socket.getAgents(uuid)
    },
    goToSettings () {
      this.$router.push({
        path: '/settings'
      })
    }
  }

}
</script>
